import React, { Suspense, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom';


const Dashboard = React.lazy(() => import('../../pages/main/dashboard/Dashboard.tsx'));

const MainLayout = () => {


    return (
        <div className="main-layout">
            <div className="main-content">
                <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                   
                        <Route path="/dashboard" element={<Dashboard />} />
                     
                    </Routes>
                </Suspense>
            </div>
        </div>
    )
}

export default MainLayout


